import { render, staticRenderFns } from "./GitControl.vue?vue&type=template&id=7324885c&scoped=true"
import script from "./GitControl.vue?vue&type=script&lang=js"
export * from "./GitControl.vue?vue&type=script&lang=js"
import style0 from "./GitControl.vue?vue&type=style&index=0&id=7324885c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7324885c",
  null
  
)

export default component.exports